import { HeartHandshake, FileSignature, ClipboardCheck } from "lucide-react";
import { FadeUp, SlideTitle, SlideConclusion } from "../Deck";

const CARDS = [
  {
    icon: HeartHandshake,
    h: "Facilitator, never provider",
    p: "We coordinate care. Clinical decisions stay with clinicians.",
  },
  {
    icon: FileSignature,
    h: "Clinician orders, not referrals",
    p: "Care starts with a doctor's order and no commission changes hands.",
  },
  {
    icon: ClipboardCheck,
    h: "Outcomes on record",
    p: "Every treatment ends in a report to the doctor.",
  },
];

export default function Slide03What() {
  return (
    <div>
      <SlideTitle className="max-w-5xl">
        PranIQ carries every doctor's order{" "}
        <em className="italic text-gold">through to recovery</em>
      </SlideTitle>
      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {CARDS.map((c, i) => (
          <FadeUp
            key={c.h}
            delay={0.1 + i * 0.1}
            className="h-full rounded-3xl border border-line bg-white p-8 transition-shadow duration-300 hover:shadow-[0_30px_60px_-40px_rgba(10,25,23,0.35)]"
          >
            <div className="flex h-11 w-11 items-center justify-center rounded-full bg-mint text-teal">
              <c.icon size={20} strokeWidth={1.8} />
            </div>
            <h3 className="mt-6 text-xl font-semibold tracking-tight">{c.h}</h3>
            <p className="mt-3 text-sm leading-relaxed text-mut">{c.p}</p>
          </FadeUp>
        ))}
      </div>
      <SlideConclusion>We match, schedule, document and report.</SlideConclusion>
    </div>
  );
}
